const regForApplicationName = /[^a-zA-Z0-9\[\]\()_ -]/g;
export const validateApplicationName = (applicationName) => {
    return regForApplicationName.test(applicationName);
};
export const removeSpecialCharacter = (applicationName) => {
    return applicationName !== undefined &&
        applicationName !== '' &&
        applicationName.length > 0 &&
        validateApplicationName(applicationName) ?
        applicationName.replace(regForApplicationName, '') : applicationName;
};
